import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DateControlComponent } from '../date-control/date-control.component';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-age-control',
  templateUrl: '../date-control/date-control.component.html',
  styleUrls: ['../date-control/date-control.component.scss'],
})
export class AgeControlComponent
  extends DateControlComponent
  implements OnInit, AfterViewInit {
  ngOnInit(): void {}

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.validators.push((control: AbstractControl) =>
      this.validateAge(control)
    );
  }

  private validateAge(control: AbstractControl): ValidationErrors | null {
    if (!this.control.required) {
      return null;
    }
    const isValid = this.getInvalidDateError(control) === null;
    if (isValid && !this.isOlderThan(control.value)) {
      return { minAge: this.control.min };
    }
    return null;
  }

  private isOlderThan(date: string): boolean {
    const birthdate = this.getDate(date);
    const now = moment();
    return birthdate < now.subtract(this.control.min, 'years');
  }
}
